<mat-nav-list>
    <ng-content select="[before]"></ng-content>

    @for (item of entries; track trackByFn($index, item)) { @if (!item.isSubmenu && !isGroup(item))
    {
    <a
        mat-list-item
        [routerLink]="item.path"
        routerLinkActive="active-menu-item"
        (click)="onItemClick()"
    >
        <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
        <span matListItemTitle>{{ item.name }}</span>
    </a>
    } @if (item.isSubmenu) {
    <a mat-list-item (click)="onSubmenuClick(item)">
        <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
        <span matListItemTitle>{{ item.name }}</span>
        <mat-icon>chevron_right</mat-icon>
    </a>
    } @if (isGroup(item)) {
    <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
        <mat-expansion-panel-header>
            <mat-panel-title>{{ item.name }}</mat-panel-title>
        </mat-expansion-panel-header>
        @for (child of item.childs; track trackByFn($index, child)) {
        <a
            mat-list-item
            [routerLink]="child.path"
            routerLinkActive="active-menu-item"
            (click)="onItemClick()"
        >
            <mat-icon matListItemIcon>{{ child.icon }}</mat-icon>
            <span matListItemTitle>{{ child.name }}</span>
        </a>
        }
    </mat-expansion-panel>
    } }

    <ng-content select="[after]"></ng-content>
</mat-nav-list>
